import { ChangeEvent, useEffect, useState } from "react";
import ChevronIcon from "assets/icons/ChevronIcon";
import SearchIcon from "assets/icons/SearchIcon";
import { InventoryFilterData } from "types";
import XIcon from "assets/icons/XIcon";
import classNames from "classnames";

import styles from "./style.module.scss";

interface SearchContainerProps {
  filterData: InventoryFilterData;
  setFilterData: (data: InventoryFilterData) => void;
}

const SearchContainer = ({
  filterData,
  setFilterData,
}: SearchContainerProps) => {
  const [inputText, setInputText] = useState(filterData.searchValue || "");

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputText(value);
    if (filterData.searchValue && !value) {
      setFilterData({ ...filterData, searchValue: null });
    }
  };

  const handleKeydown = (e: any) => {
    if (!inputText || inputText === filterData.searchValue) {
      return;
    }
    if (e.keyCode === 13) {
      setFilterData({ ...filterData, searchValue: inputText });
    }
  };

  const handleClearSearch = () => {
    setInputText("");
    if (filterData.searchValue) {
      setFilterData({ ...filterData, searchValue: null });
    }
  };

  const handleSearchClick = () => {
    if (!inputText || inputText === filterData.searchValue) {
      return;
    }

    setFilterData({ ...filterData, searchValue: inputText });
  };

  useEffect(() => {
    if (!filterData.searchValue && inputText) {
      setInputText("");
    }
    //eslint-disable-next-line
  }, [filterData.searchValue]);

  return (
    <div
      className={styles.textualSearchContainer}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.searchBarIcon}>
        <SearchIcon />
      </div>
      <div className={styles.inputBox}>
        <input
          type="search"
          value={inputText}
          onChange={handleInputChange}
          onKeyDown={handleKeydown}
          placeholder="Search Datasets"
          className={styles.searchBarInput}
        />
        <div
          className={inputText ? styles.crossBtn : styles.disabledCrossBtn}
          onClick={handleClearSearch}
        >
          <XIcon variant="new" />
        </div>
      </div>
      <div
        className={classNames(styles.searchBarButton, {
          [styles.searchedButton]: filterData.searchValue,
        })}
        onClick={handleSearchClick}
      >
        <ChevronIcon direction="right" />
      </div>
    </div>
  );
};

export default SearchContainer;
